import { setElementInnerHTML, setElementOnClick } from '../../../../shared/scripts/ui_utils/DomUtils.ts';
import { CA } from '../../../../shared/scripts/analytics/Analytics.ts';
import { AnalyticEventCategory, AnalyticEventType, AnalyticEventValue } from '../../../../../shared/entity_datas/EntityDatas.ts';
import { UIUtilsEjsVariables } from '../../../../shared/scripts/UIUtilsEjsVariables.ts';
import { PlayerEnums } from '../../../../../shared/GameEnums.ts';
const RoomInfoMessage = PlayerEnums.RoomInfoMessage;
import { showBecomeMemberDialog } from '../../../../shared/scripts/ui_popup/showBecomeMemberDialog.ts';
import { uiManagerEvents } from '../../../../shared/scripts/EntryShared.ts';
import { isSubscriptionOverlayVariant } from '../../../../shared/scripts/store/subscription_overlay/subscriptionOverlayABTest.ts';
export class UIRoomCenterInfoMessageController {
    setMessage(message) {
        switch(message){
            case RoomInfoMessage.None:
                this.hide();
                return;
            case RoomInfoMessage.ClickReady:
                this.setClickReadyMessage();
                break;
            case RoomInfoMessage.PremiumItemSelected:
                this.setPremiumItemMessage();
                break;
        }
        this.show();
    }
    show() {
        this.container.classList.add('show-message');
    }
    hide() {
        this.container.classList.remove('show-message');
    }
    setClickReadyMessage() {
        const message = {
            key: 'strings:roomPage.allPlayersNeedToBeReady'
        };
        setElementInnerHTML(this.infoMessage, message);
    }
    setPremiumItemMessage() {
        const message = {
            key: 'strings:roomPage.premiumItemNotOwned'
        };
        setElementInnerHTML(this.infoMessage, message);
        this.setPremiumItemCTA();
    }
    setPremiumItemCTA() {
        const cta = this.infoMessage.querySelector('#premium-item-cta');
        if (cta == null) return;
        setElementOnClick(cta, ()=>{
            if (UIUtilsEjsVariables.isUserOnDiscord) showBecomeMemberDialog('gameplay', AnalyticEventValue.PopupMembershipIncentiveDiscordGeneral);
            else if (isSubscriptionOverlayVariant()) uiManagerEvents.premiumMembershipCheckAction();
            void UIRoomCenterInfoMessageController.sendBecomeMemberAnalyticEvent();
        });
        if (UIUtilsEjsVariables.isUserOnDiscord || isSubscriptionOverlayVariant()) cta.removeAttribute('href');
    }
    static async sendBecomeMemberAnalyticEvent() {
        const eventData = {
            type: AnalyticEventType.ABTestClickAnalytics,
            category: AnalyticEventCategory.ABTestClickAnalytics,
            floatValue: AnalyticEventValue.RoomPremiumItemInfoMessageBecomeAMemberText
        };
        void CA.sendAnalyticEvent(eventData);
    }
    constructor(){
        this.container = document.getElementsByClassName('room-center-footer')[0];
        this.infoMessage = document.getElementById('room-info-message');
    }
}
